import { createStore } from 'vuex'
import * as userApi from '../api/user'
import * as designApi from '../api/design'
import * as paymentApi from '../api/payment'

export default createStore({
  state: {
    userInfo: null,
    token: localStorage.getItem('token') || ''
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userInfo: state => state.userInfo
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.userInfo = null
      localStorage.removeItem('token')
    }
  },
  actions: {
    // 用户登录
    async login({ commit }, loginData) {
      try {
        const response = await userApi.login(loginData)
        const { token, userInfo } = response.data.data
        
        // 保存token
        commit('SET_TOKEN', token)
        // 保存用户信息
        commit('SET_USER_INFO', userInfo)
        
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 用户注册
    async register({ commit }, registerData) {
      try {
        const response = await userApi.register(registerData)
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 获取用户信息
    async getUserInfo({ commit }) {
      try {
        const response = await userApi.getUserInfo()
        commit('SET_USER_INFO', response.data.data)
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 获取当前用户详情
    async getCurrentUser({ commit }) {
      try {
        const response = await userApi.getCurrentUser()
        commit('SET_USER_INFO', response.data.data)
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 退出登录
    logout({ commit }) {
      commit('CLEAR_AUTH')
    },
    
    // 充值积分（已迁移到 payment 模块，此函数保留以兼容旧代码）
    async recharge({ commit }, amount) {
      console.warn('警告：store.actions.recharge 已废弃，请使用 payment.createPayment');
      // 如果还需要使用此方法，可以调用 payment API
      try {
        const response = await paymentApi.createPayment({
          description: '在线充值',
          amount: amount * 100, // 转换为分
          attach: `user_id:${state.userInfo?.id || ''},type:recharge`,
          expireMinutes: 30
        });
        return response;
      } catch (error) {
        throw error;
      }
    },
    
    // 一键生成门头设计
    async generateDesign({ commit }, designData) {
      try {
        const response = await designApi.generateDesign(designData)
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 一键同款生成
    async generateSameDesign({ commit }, designData) {
      try {
        const response = await designApi.generateSameDesign(designData)
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 现场还原AI修改
    async aiModify({ commit }, modifyData) {
      try {
        const response = await designApi.aiModify(modifyData)
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 获取设计历史记录
    async getDesignHistory({ commit }, params) {
      try {
        const response = await designApi.getDesignHistory(params)
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 上传图片
    async uploadImage({ commit }, formData) {
      try {
        const response = await designApi.uploadImage(formData)
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 重新生成设计
    async regenerateDesign({ commit }, designId) {
      try {
        const response = await designApi.regenerateDesign(designId)
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 获取一键同款生成记录
    async getSameDesignHistory({ commit }, params) {
      try {
        const response = await designApi.getSameDesignHistory(params)
        return response
      } catch (error) {
        throw error
      }
    },
    
    // 获取图片列表
    async getImageList({ commit }, params) {
      try {
        const response = await designApi.getImageList(params)
        return response
      } catch (error) {
        throw error
      }
    }
  },
  modules: {
  }
})
